module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview"
  }, [(_vm.$root.isMobile) ? _c('span', {
    staticClass: "menu-disclaimer"
  }, [_vm._v("\n        СПЕЦИАЛЬНЫЙ ПРОЕКТ\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "preview-cols"
  }, [(!_vm.$root.isMobile) ? _c('div', {
    staticClass: "preview-col leftside"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _c('div', {
    staticClass: "preview-col leftside"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), (_vm.matches.items) ? _c('div', {
    staticClass: "preview-col rightside"
  }, [_c('div', {
    staticClass: "top-slider"
  }, [_c('swiper', {
    ref: "top-slider",
    attrs: {
      "options": _vm.topSliderOptions
    },
    on: {
      "slideChange": _vm.getActiveIndex,
      "init": _vm.getActiveIndex
    }
  }, _vm._l((_vm.matches.items), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('div', {
      staticClass: "top-slider-item"
    }, [_c('div', {
      staticClass: "top-slider-item-command"
    }, [_c('div', {
      staticClass: "country-img"
    }, [_c('img', {
      attrs: {
        "src": item.fkParticipants1.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "item-title"
    }, [_vm._v("Сборная")]), _vm._v(" "), _c('span', {
      staticClass: "country-name"
    }, [_vm._v(_vm._s(item.fkParticipants1.name))])]), _vm._v(" "), _c('div', {
      staticClass: "total"
    }, [_c('span', [_vm._v(_vm._s(item.fkParticipants1.goals))]), _vm._v(" "), _c('span', [_vm._v("X")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.fkParticipants2.goals))])]), _vm._v(" "), _c('div', {
      staticClass: "top-slider-item-command"
    }, [_c('div', {
      staticClass: "country-img"
    }, [_c('img', {
      attrs: {
        "src": item.fkParticipants2.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "item-title"
    }, [_vm._v("Сборная")]), _vm._v(" "), _c('span', {
      staticClass: "country-name"
    }, [_vm._v(_vm._s(item.fkParticipants2.name))])])])])
  }))], 1), _vm._v(" "), (!_vm.$root.isMobile) ? _c('div', {
    staticClass: "top-slider-info"
  }, [_c('div', {
    staticClass: "top-slider-datetime"
  }, [_c('div', {
    staticClass: "date"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('calendar')], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.date))])]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('watch')], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.time))])])]), _vm._v(" "), _c('div', {
    staticClass: "top-slider-nav"
  }, [_c('a', {
    staticClass: "top-prev-slide",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.$root.gaSend('main', 'click', 'day slider')
      }
    }
  }, [_c('arrow-prev')], 1), _vm._v(" "), _c('a', {
    staticClass: "top-next-slide",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.$root.gaSend('main', 'click', 'day slider')
      }
    }
  }, [_c('arrow-next')], 1)])]) : _vm._e(), _vm._v(" "), (_vm.menuState || !_vm.$root.isMobile) ? _c('div', {
    staticClass: "navigation-slider"
  }, [_c('swiper', {
    ref: "navigation-slider",
    attrs: {
      "options": _vm.navigationSliderOptions
    }
  }, _vm._l((_vm.matches.items), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      class: {
        'active-item': _vm.currentIndex == index
      }
    }, [_c('div', {
      staticClass: "navigation-slider-item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.currentIndex = index
        }
      }
    }, [_c('div', {
      staticClass: "navigation-slider-item-command"
    }, [_c('div', {
      staticClass: "country-img"
    }, [_c('img', {
      attrs: {
        "src": item.fkParticipants1.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "country-name"
    }, [_vm._v(_vm._s(item.fkParticipants1.name))])]), _vm._v(" "), _c('span', {
      staticClass: "delimiter"
    }, [_vm._v("X")]), _vm._v(" "), _c('div', {
      staticClass: "navigation-slider-item-command"
    }, [_c('div', {
      staticClass: "country-img"
    }, [_c('img', {
      attrs: {
        "src": item.fkParticipants2.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "country-name"
    }, [_vm._v(_vm._s(item.fkParticipants2.name))])])])])
  })), _vm._v(" "), (!_vm.$root.isMobile) ? _c('div', {
    staticClass: "navigation-slider-arrows"
  }, [_c('a', {
    staticClass: "navigation-prev-slide",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.$root.gaSend('main', 'click', 'all slider')
      }
    }
  }, [_c('arrow-prev')], 1), _vm._v(" "), _c('a', {
    staticClass: "navigation-next-slide",
    attrs: {
      "href": "#"
    }
  }, [_c('arrow-next')], 1)]) : _vm._e()], 1) : _vm._e()]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("\n                БОЛЬШЕ "), _c('br'), _vm._v("     ФУТБОЛА\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-text"
  }, [_c('p', [_vm._v("\n                    Редакция «Чемпионата» собирает для вас интересную статистику самых зрелищных матчей главного футбольного события года. Следите за ходом турнира на проекте «Больше футбола» и будьте в курсе всех деталей!\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("\n                БОЛЬШЕ "), _c('br'), _vm._v("  ФУТБОЛА\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-text"
  }, [_c('p', [_vm._v("\n                    Редакция «Чемпионата» собирает для вас интересную статистику самых зрелищных матчей главного футбольного события года. Следите за ходом турнира на проекте «Больше футбола» и будьте в курсе всех деталей!\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43985b3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/preview.vue
// module id = 644
// module chunks = 1